import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=be10bd76"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"
import style0 from "./technology.vue?vue&type=style&index=0&id=be10bd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports